import angular from 'angular'

export default ($parse, $rootScope) => ({
    restrict: 'E',
    scope: false,
    link(scope, element, attr) {
        element.hide();
        angular.forEach(attr, function eventIterator(fnExpression, eventName) {
            var fn = $parse(fnExpression)
            $rootScope.$on(eventName, function eventHandler($event, $args) {
                var ctx = { $event, $args, $arguments: arguments };
                fn(scope, ctx);
            });
        });
    }
});